import styled from "styled-components";

const Wrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const NewsContent = (props: { children: any }) => {
  return <Wrapper>{props.children}</Wrapper>;
};

export default NewsContent;
